import React, { Component } from 'react'

import '../../assets/css/app.css'
import 'bootstrap/dist/css/bootstrap.min.css'

class Footer extends Component {
  render() {
    return (
      <div>
        <footer className="container-fluid">
          <div className="row">
            <div className="col col-md text-right bg-yellow text-white">
              <div className="p-2 text-center">
              Copyright &copy;2023                    
                <span className="d-md-inline"> WHITE GLOVE DELIVERY AND SERVICES </span>
                {/* <span className="d-sm-inline"> managed by World Reward Solutions.</span> */}
              </div>
            </div>
          </div>
        </footer>
      </div>
    )
  }
}

export default Footer
